import client from '../../client';

const ARTICLES = {
  getArticles(params) {
    return client.get('/blog/articles', params)
  }
}

export default ARTICLES;
